export default "__VITE_ASSET__7bfdd838__"